// extracted by mini-css-extract-plugin
export default {"main":"_69e2ea5923","tit":"_53ba8ab2bb","maintitle":"_63cd4a4f26","ylw":"_672c5fa0f4","white":"_84ec92f935","mv_title":"_44cc6e8967","mv_nc":"_33401306f3","mv_in":"_9c91c06447"};